import BrokeragePipelinesCalendarContainer from './containers/BrokeragePipelinesCalendarContainer'

export default BrokeragePipelinesCalendarContainer
